import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  breakpoint: {
    mobileBreakpoint: 'sm'
  },
  theme: {
    themes: {
      light: {
        grey: {
          base: '#9E9E9E',
          lighten4: '#F7FAFC'
        },
        primary: '#1D262C'
      }
    }
  }
})
